import { createSelector } from '@reduxjs/toolkit';
import { createInputBindings } from '@ff-scene-plugins/gift-redux/slices/inputsSlice';
import { createOptionBindings, selectSizeByVariableId } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { canDisplayImage } from '@gift-variable-plugins/photo-shared/canDisplayImage';
import { PhotoVariableInput, ProcessedPhotoInput, UnprocessedPhotoInput } from '@gift-variable-plugins/photo-shared/PhotoVariableInput';
import { PhotoVariableOptions } from '@gift-variable-plugins/photo-shared/PhotoVariableOptions';
import { toPhotoUrl } from '@gift-variable-plugins/photo-shared/toPhotoUrl';

const { createInputSelector, createInputUpdater, selectInputById }
    = createInputBindings<PhotoVariableInput>();

const { createOptionSelector } = createOptionBindings<PhotoVariableOptions>();

export const selectClipById = createSelector([
    createOptionSelector(o => o.clip),
    createInputSelector(i => i.fit),
    selectSizeByVariableId
], (clip, fit, size) => {

    if (!size || fit === 'contain') {
        return;
    }

    if (clip && clip.paths.length > 0) {
        return clip;
    }

    return {
        paths: [`M 0,0 H ${size.width}V ${size.height}H 0 Z`],
        width: size.width,
        height: size.height
    };
});

export const selectFilterById = createInputSelector(i => i.filter);
export const updateFilter = createInputUpdater('filter');

const { createInputSelector: createPhotoSelector }
    = createInputBindings<UnprocessedPhotoInput | ProcessedPhotoInput>();

export const selectCuidById = createPhotoSelector(i => i.cuid);
export const selectFileNameById = createPhotoSelector(i => i.fileName);
export const selectStatusById = createPhotoSelector(i => i.status);

const { createInputSelector: createProcessedInputSelector, createInputUpdater: createProcessedInputUpdater }
    = createInputBindings<ProcessedPhotoInput>();

export const selectCropBoxById = createProcessedInputSelector(i => i.cropBox);
export const updateCropBox = createProcessedInputUpdater('cropBox');

export const selectImageWidthById = createProcessedInputSelector(i => i.imageWidth);
export const selectImageHeightById = createProcessedInputSelector(i => i.imageHeight);

export const selectImageSizeById = createSelector([
    selectImageWidthById,
    selectImageHeightById
], (width, height) => width && height
    ? { width, height }
    : undefined);

export const selectPrivateAssetUrl = createSelector([
    selectInputById,
    (state: GiftPdpState) => state.auth.jwt
], (input, jwt) => canDisplayImage(input)
    ? toPhotoUrl(input, jwt)
    : undefined);